import type { Event } from '../types';
import type { PublicHoliday } from '../network/leavePolicy';

/** Matches the 'Public holiday' entry in EVENT_TYPES (its calendar colour). */
export const PUBLIC_HOLIDAY_EVENT_TYPE = 'Public holiday';

const BLANK_IMAGE =
  'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';

/** Public holidays as calendar events, so the calendar shows them like leave. */
export function holidaysToEvents(holidays: PublicHoliday[]): Event[] {
  return holidays.map((holiday) => ({
    id: `holiday-${holiday.id}`,
    type: PUBLIC_HOLIDAY_EVENT_TYPE,
    title: holiday.half_day ? `${holiday.name} (half day)` : holiday.name,
    description: '',
    start: { date: holiday.date, time: 'start_of_day' },
    startTimeOfDay: 'the start of the day',
    end: { date: holiday.date, time: 'end_of_day' },
    endTimeOfDay: holiday.half_day ? 'midday' : 'the end of the day',
    userFirstName: '',
    userLastName: '',
    userFullName: holiday.name,
    userPictureURL: BLANK_IMAGE,
  }));
}
